import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Stack, TextField } from "@mui/material";
import PhoneInput from "./PhoneInput";
import EmailInput from "./EmailInput";
import CheckIcon from "@mui/icons-material/Check";
import FileInput from "./FileInput";

function EmployeeDetails({ setData, defaultData }) {
  const methods = useForm();
  const { register, handleSubmit, formState, setValue, reset } = methods;
  const { errors } = formState;
  const [time, setTime] = useState(0);

  const [file, setFile] = useState();

  useEffect(() => {
    reset();
    console.log("resetting");
    Object.keys(defaultData).forEach((key) => {
      console.log(key, defaultData[key]);
      setValue(key, defaultData[key]);
    });
    setTime(new Date().getTime());
  }, [defaultData]);

  const onSubmit = (data) => {
    // console.log("submitted", data);
    setData({ ...data, resume: file });
  };

  return (
    <div>
      <h3>Applicant Details</h3>
      <FormProvider {...methods}>
        <form
          key={time}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          style={{ width: "100%" }}
        >
          <Stack spacing={2}>
            <TextField
              label="Full Name"
              // InputLabelProps={defaultData["name"]}
              {...register("name", {
                validate: (value) => {
                  if (!value) return "Full Name is required";
                  let vArr = value.split(" ");
                  if (vArr.length < 2)
                    return "First and Last Names are Required";
                  const regex = /[0-9]/g;
                  const found = value.match(regex);
                  if (found) return "Name cannot include numbers";
                },
              })}
              error={errors.name ? true : false}
              helperText={errors.name?.message}
            />
            <PhoneInput name="phone" label="Phone Number" />
            <EmailInput
              name="email"
              label="E-Mail"
              register={register}
              validate={(value) => {
                if (value.endsWith("boundlessinc.com"))
                  return "Personal E-Mail cannot be a company E-Mail";
                if (!value) return "E-Mail is required";
              }}
              errors={errors}
            />
            <TextField
              label="City of Residence"
              {...register("city", { required: "City is required" })}
              error={errors.city ? true : false}
              helperText={errors.city?.message}
            />
            <TextField
              label="State of Residence"
              {...register("state", { required: "State is required" })}
              error={errors.state ? true : false}
              helperText={errors.state?.message}
            />
            <TextField
              label="Zip Code"
              {...register("zip", { required: "Zip Code is required" })}
              error={errors.zip ? true : false}
              helperText={errors.zip?.message}
            />
            <FileInput
              name={"resume"}
              label={"Resume"}
              register={register}
              errors={errors}
              setFile={setFile}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 24,
              }}
            >
              <div style={{ flex: 1 }} />
              <Button
                type="submit"
                variant="contained"
                sx={{ flex: 1 }}
                endIcon={<CheckIcon />}
              >
                Submit
              </Button>
            </div>
          </Stack>
        </form>
      </FormProvider>
    </div>
  );
}

export default EmployeeDetails;
